import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/*
 * © 2023 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { EmbersNavDot } from './verticalNavStyles';
import React, { useEffect, useRef, useState } from 'react';
import classnames from 'classnames';
// the purpose of the VerticalNavDot is to delay its appearance when it is the *bottom*, extra dot.
//  This delay is to keep it in synch with the animation of opening the tree item and its line.
export var VerticalNavDot = function VerticalNavDot(props) {
  var isBottomDot = props.isBottomDot,
    level = props.level,
    lineHeight = props.lineHeight,
    lineOffset = props.lineOffset;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showBottomDot = _useState2[0],
    setShowBottomDot = _useState2[1];
  var timeoutRef = useRef(undefined);
  useEffect(function () {
    if (props.isBottomDot) {
      timeoutRef.current = setTimeout(function () {
        setShowBottomDot(true);
      }, 200);
    }
    return function () {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);
  var dotStyle = {
    '--tree-view-finalDotLeft': "".concat(24 * (level + 1) - 2, "px"),
    '--tree-view-finalDotTop': lineHeight && lineOffset && "".concat(lineHeight - (level === 0 ? 15 : lineOffset) - 2.5, "px")
  };
  if (isBottomDot) {
    dotStyle.visibility = showBottomDot ? 'visible' : 'hidden';
  }
  return /*#__PURE__*/React.createElement(EmbersNavDot, {
    style: dotStyle,
    className: classnames('EmbersNav-dot', {
      'EmbersNav-bottom-dot': isBottomDot
    })
  });
};